/**
 * Created by jpilz on 2/13/17.
 */
import $ from 'jquery';

export default class jdmApiUtil {

    constructor(context) {
        this.name = "jdmApiUtil";
        this.context = context;
        
    }

    checkUser() {

        return this.tryAPIAutoLogin();
    }

    tryAPIAutoLogin() {

        console.log("jdmApiUtil:tryAPIAutoLogin: apiUserID: %o",this.context.apiUserID);
        let callData = JSON.stringify({});
        let url = this.context.generateApiUrl('/Users/' + this.context.apiUserID);
        console.log("jdmApiUtil:tryAPIAutoLogin: url: %o",url);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'get',
                crossDomain: true,
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request)  => {
                console.log('jdmApiUtil:tryAPIAutoLogin data: %o', data );
                resolve(true);
            }).fail((responseData, textStatus, errorThrown) =>{
                console.log("jdmApiUtil:tryAPIAutoLogin Error:");
                console.log(textStatus);
                console.log(textStatus);

                resolve(false);
            });
        });

    } 

    apiLogin() {

        /*
        let url = this.context.apiEntryPointUrl + '/Users/login';

        console.log("jdmApiUtil:apiLogin: url:%s",url);
        //console.table(context,["index","Value","name","_latestValue"]);

        let callData = JSON.stringify({"username": this.context.apiUserName, "password": this.context.apiAppId, ttl:86400});

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'post',
                crossDomain: true,
                headers: this.context.apiContentType,
                data: callData
            }).done((response, textResponse, request) => {

                console.log("jdmApiUtil:apiLogin: response: %o  request: %o", response, request);

                //this.context.apiAccessToken = response.id;

                if(this.handleApiLoginAttempt(request,""))
                {
                    console.log("jdmApiUtil:apiLogin: resolve:true");
                    resolve(true);
                }
                else
                {
                    console.log("jdmApiUtil:apiLogin: resolve:false");
                    resolve(false);
                }
                
            }).fail((responseData, textStatus, errorThrown) =>{
                console.log("jdmApiUtil:apiLogin Error:");
                console.log(textStatus);
                if(typeof responseData.response !== undefined)
                {
                    //alert('Error connscting to API');
                }
                reject(false);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error: JDM API Login Error. <br> <small>This error has been logged</small>"},"messageModel");
            });
        });
        */

    } 
    
    handleApiLoginAttempt(response,type)
    {
        /*
        console.log("handle API Login Attempt");
        //console.log(response);

        if(typeof response.status !== undefined)
        {
            if((response.status === 200) && ((response.responseJSON.id.length > 63) || (response.responseJSON.email.length > 5)) )
            {
                console.log("jdmApiUtil:handleApiLoginAttempt: login");

                if(type != "auto")
                {
                    this.context.apiUserID = response.responseJSON.userId;
                    this.context.apiAccessToken = response.responseJSON.id;
                    console.log('jdmApiUtil:handleApiLoginAttempt:  ******************* apiAccessToken: %o', response.responseJSON.id);
                    
                    //this.context.createCookie('access_token',response.responseJSON.id,1);
                    //this.context.createCookie('access_id',response.responseJSON.userId,1);
                }

                console.debug("jdmApiUtil:handleApiLoginAttempt: Sending API Login");
                console.log("jdmApiUtil:handleApiLoginAttempt:handleApiLoginAttempt:");
                console.log(this.context.loginStatusObj());
                this.context.loginStatusObj.valueHasMutated();
                return true;
            }
            else
            {
                console.log("jdmApiUtil:handleApiLoginAttempt:log failed - Inside response")
                console.log(response.responseJSON.id.length );
                return false;
            }
        }
        else
        {
            console.log("jdmApiUtil:handleApiLoginAttempt:log failed");
            return false;
        }
        */

    }



}




// WEBPACK FOOTER //
// ./src/objects/jdmApiUtil.js